import axios from 'axios';
import {
  ADD_PERSON,
  ADD_PERSON_SUCCESS,
  ADD_PERSON_FAILED,
  FETCH_PEOPLE,
  FETCH_PEOPLE_FAILED,
  FETCH_PEOPLE_SUCCESS,
  RESET_PERSON_ADDED,
  FETCH_PERSON,
  FETCH_PERSON_SUCCESS,
  FETCH_PERSON_FAILED,
  RESET_PERSON_EDITED,
  EDIT_PERSON_SUCCESS,
  EDIT_PERSON_FAILED,
  EDIT_PERSON,
  DELETE_PERSON_SUCCESS,
  DELETE_PERSON,
  RESET_PERSON_DELETED,
  DELETE_PERSON_FAILED,
  UPLOAD_PEOPLE_FROM_FILE,
  UPLOAD_PEOPLE_FROM_FILE_SUCCESS,
  PEOPLE_UPLOADED_FROM_FILE_RESET,
  RESET_FILE_UPLOAD,
  UPLOAD_PEOPLE_FROM_FILE_FAILED,
  UPLOAD_PEOPLE_FROM_FILE_CONFIRM,
  UPLOAD_PEOPLE_FROM_FILE_CONFIRM_SUCCESS,
  UPLOAD_PEOPLE_FROM_FILE_CONFIRM_FAILED
} from './types';


import bugsnag from '@bugsnag/js';
import { notification } from 'antd';
import { getCookie } from '../../utils/helpers';
import cw from '../../utils/commonwords';
import { API_URL } from '../../config/environment';
import { signOutUser } from '../auth/actions';
import { fetchGroups, fetchGroupPeople } from '../groups/actions';
import { RESET_GROUP_PAGE } from '../groups/types';
const bugsnagClient = bugsnag('ab84c0b67d6464d40ea9bc8050d778e7');

export const resetFileUpload = () => {
  return dispatch => {
    dispatch({ type: RESET_FILE_UPLOAD });
  };
};
export const uploadPeopleFromFile = (
  excelFile,
  limit,
  page,
  userId,
  intl,
  siteLanguage
) => {
  return dispatch => {
    dispatch({ type: UPLOAD_PEOPLE_FROM_FILE });

    const upurl = `/persons/_bulk?mode=excelUpload&userId=${userId}`;
    const file = new FormData();
    file.append('file', excelFile);

    axios({
      method: 'POST',
      url: `${API_URL}${upurl}`,
      headers: {
        'content-type': 'multipart/form-data',
        'x-access-token': `${getCookie('user_token')}`
      },
      data: file
    })
      .then(response => {
        if (response.data.status === 200) {
          dispatch({
            type: UPLOAD_PEOPLE_FROM_FILE_SUCCESS,
            payload: response.data
          });
          setTimeout(() => {
            dispatch({
              type: PEOPLE_UPLOADED_FROM_FILE_RESET
            });
          }, 100);
        } else if (response.data.status === 400) {
          dispatch({ type: UPLOAD_PEOPLE_FROM_FILE_FAILED });
        } else if (response.data.status === 403) {
          dispatch({ type: UPLOAD_PEOPLE_FROM_FILE_FAILED });
        } else if (
          response.data.status === 498 ||
          response.data.status === 401
        ) {
          dispatch(signOutUser(userId, intl, siteLanguage));
        } else {
          dispatch({ type: UPLOAD_PEOPLE_FROM_FILE_FAILED });
        }
      })
      .catch(err => {
        dispatch({ type: ADD_PERSON_FAILED });
        notification.error({
          message: intl.formatMessage(cw['FailedAddPerson'])
        });
        bugsnagClient.notify(err);
      });
  };
};
export const uploadPeopleFromFileConfirm = (
  data,
  limit,
  page,
  userId,
  intl,
  siteLanguage
) => {
  return dispatch => {
    dispatch({ type: UPLOAD_PEOPLE_FROM_FILE_CONFIRM });

    const upurl = `/persons/_bulk?mode=excelUpload&userId=${userId}&fileName=${data.fileName
      }${data.groupId ? `&groupId=${data.groupId}` : ''}`;

    axios({
      method: 'POST',
      url: `${API_URL}${upurl}`,
      headers: {
        Accept: 'application/json',
        'x-access-token': `${getCookie('user_token')}`
      }
    })
      .then(response => {
        dispatch({
          type: UPLOAD_PEOPLE_FROM_FILE_CONFIRM_SUCCESS,
          payload: { data: {} },
          uploadConfirmed: true
        });

        // setTimeout(() => {
        //   dispatch({
        //     type: RESET_FILE_UPLOAD
        //   });
        // }, 100);
        if (response.data.status === 200) {
          if (data.groupId) {
            // dispatch(
            //   fetchGroupPeople(data.groupId, userId, intl, siteLanguage)
            // );
            dispatch(fetchGroups(userId, intl, siteLanguage));
          } else {
            // dispatch(
            //   dispatch(fetchPeople(userId, limit, page, intl, siteLanguage))
            // );
          }
          dispatch(fetchPeople(userId, limit, page, intl, siteLanguage));
        } else if (response.data.status === 400) {
          dispatch({ type: UPLOAD_PEOPLE_FROM_FILE_CONFIRM_FAILED });
        } else if (response.data.status === 403) {
          dispatch({ type: UPLOAD_PEOPLE_FROM_FILE_CONFIRM_FAILED });
        } else if (
          response.data.status === 498 ||
          response.data.status === 401
        ) {
          dispatch(signOutUser(userId, intl, siteLanguage));
        } else {
          dispatch({ type: UPLOAD_PEOPLE_FROM_FILE_CONFIRM_FAILED });
        }
      })
      .catch(err => {
        dispatch({ type: ADD_PERSON_FAILED });
        bugsnagClient.notify(err);
      });
  };
};
export const addPerson = (data, limit, page, userId, intl, siteLanguage) => {
  // console.log({ data, limit, page, userId, intl, siteLanguage })
  return dispatch => {
    dispatch({ type: ADD_PERSON });
    let url = '/persons';
    if (data.personMeta.groups) {
      url = `/groups/${data.personMeta.groups}/persons`;
    }
    const gid = data.personMeta.groups;
    delete data.personMeta.groups;

    axios({
      method: 'POST',
      url: `${API_URL}${url}`,
      headers: {
        Accept: 'application/json',
        'x-access-token': `${getCookie('user_token')}`
      },
      data
    }).then(response => {
      if (response.data.status === 200) {
        dispatch({
          type: ADD_PERSON_SUCCESS,
          payload: response.data
        });
        setTimeout(() => {
          dispatch({
            type: RESET_PERSON_ADDED
          });
        }, 100);
        dispatch(fetchPeople(userId, limit, page, intl, siteLanguage));
        dispatch(fetchGroups(userId, intl, siteLanguage));

        if (gid) {
          dispatch(fetchGroupPeople(gid, userId, intl, siteLanguage));
        }
        notification.success({
          message: intl.formatMessage(cw['SuccessAddPerson'])
        });
      } else if (response.data.status === 400 && response.data.code === 'INVALID_PARAMETERS') {
        notification.error({
          message: intl.formatMessage(cw['FailedAddPerson']),
          description: intl.formatMessage(cw['InvalidInputs'])
        });
        dispatch({ type: ADD_PERSON_FAILED });
      } else if (response.data.status === 400) {
        notification.error({
          message: intl.formatMessage(cw['FailedAddPerson'])
        });
        dispatch({ type: ADD_PERSON_FAILED });
      } else if (
        response.data.status === 498 ||
        response.data.status === 401
      ) {
        dispatch(signOutUser(userId, intl, siteLanguage));
      } else {
        notification.error({
          message: intl.formatMessage(cw['FailedAddPerson'])
        });
        dispatch({ type: ADD_PERSON_FAILED });
      }
    })
      .catch(err => {
        dispatch({ type: ADD_PERSON_FAILED });
        notification.error({
          message: intl.formatMessage(cw['FailedAddPerson'])
        });
        bugsnagClient.notify(err);
      });
  };
};
export const fetchPeople = (userId, limit, page, intl, siteLanguage, query) => {
  return dispatch => {
    dispatch({ type: FETCH_PEOPLE, query: query });
    axios({
      method: 'GET',
      url: `${API_URL}/persons?sortBy=First Name&limit=${limit ||
        1000}&page=${page || 1}${query ? `&query=${query}` : ''}`,
      headers: {
        Accept: 'application/json',
        'x-access-token': `${getCookie('user_token')}`
      }
    })
      .then(response => {
        if (response.data.status === 200) {
          dispatch({
            type: FETCH_PEOPLE_SUCCESS,
            payload: response.data,
            peoplePage: page,
            query: query
          });
          dispatch({
            type:RESET_GROUP_PAGE
          })
        } else if (
          response.data.status === 498 ||
          response.data.status === 401
        ) {
          dispatch(signOutUser(userId, intl, siteLanguage));
        } else if (response.data.status === 404) {
          dispatch({
            type: FETCH_PEOPLE_SUCCESS,
            payload: { data: { persons: [] } },
            peoplePage: page,
            query: query
          });
        } else {
          dispatch({ type: FETCH_PEOPLE_FAILED });
        }
      })
      .catch(err => {
        dispatch({ type: FETCH_PEOPLE_FAILED });
        // notification.error({
        //   message: intl.formatMessage(cw['Failed']),
        //   description: `Failed to fetch people`
        // });
        bugsnagClient.notify(err);
      });
  };
};
export const fetchPerson = (personId, userId, intl, siteLanguage) => {
  return dispatch => {
    dispatch({ type: FETCH_PERSON });
    axios({
      method: 'GET',
      url: `${API_URL}/persons/${personId}`,
      headers: {
        Accept: 'application/json',
        'x-access-token': `${getCookie('user_token')}`
      }
    })
      .then(response => {
        if (response.data.status === 200) {
          dispatch({
            type: FETCH_PERSON_SUCCESS,
            payload: response.data
          });
        } else if (
          response.data.status === 498 ||
          response.data.status === 401
        ) {
          dispatch(signOutUser(userId, intl, siteLanguage));
        } else {
          dispatch({ type: FETCH_PERSON_FAILED });
        }
      })
      .catch(err => {
        dispatch({ type: FETCH_PERSON_FAILED });
        // notification.error({
        //   message: intl.formatMessage(cw['Failed']),
        //   description: `Failed to fetch person`
        // });
        bugsnagClient.notify(err);
      });
  };
};
export const deletePerson = (
  ids,
  limit,
  page,
  userId,
  intl,
  siteLanguage,
  groupId
) => {
  return dispatch => {
    const qIds = [].concat(ids);
    dispatch({ type: DELETE_PERSON });
    axios({
      method: 'POST',
      url: `${API_URL}/persons/_delete`,
      headers: {
        Accept: 'application/json',
        'x-access-token': `${getCookie('user_token')}`
      },
      data: { ids: qIds }
    }).then(response => {
      if (response.data.status === 200) {
        dispatch({
          type: DELETE_PERSON_SUCCESS
        });
        notification.success({
          message: intl.formatMessage(cw.Success),
          description: `${qIds.length} ${qIds.length === 1 ? intl.formatMessage(cw['PersonDeleted']) : intl.formatMessage(cw['PeopleDeleted'])}.`
        });

        if (groupId) {
          dispatch(fetchGroupPeople(groupId, userId, intl, siteLanguage));
        }
        dispatch(fetchPeople(userId, limit, page, intl, siteLanguage));
        dispatch(fetchGroups(userId, intl, siteLanguage));
        setTimeout(() => {
          dispatch({
            type: RESET_PERSON_DELETED
          });
        }, 100);
      } else if (
        response.data.status === 498 ||
        response.data.status === 401
      ) {
        dispatch(signOutUser(userId, intl, siteLanguage));
      } else {
        notification.error({
          message: intl.formatMessage(cw['Failed']),
          description: [].concat(ids).length === 1 ? intl.formatMessage(cw['DeletePersonFailed']) : intl.formatMessage(cw['DeletePeopleFailed']),
        });
        dispatch({ type: DELETE_PERSON_FAILED });
      }
    }).catch(err => {
      dispatch({ type: DELETE_PERSON_FAILED });
      notification.error({
        message: intl.formatMessage(cw['Failed']),
        description: [].concat(ids).length === 1 ? intl.formatMessage(cw['DeletePersonFailed']) : intl.formatMessage(cw['DeletePeopleFailed']),
      });
      bugsnagClient.notify(err);
    });
  };
};
export const editPerson = (
  data,
  uuid,
  limit,
  page,
  userId,
  intl,
  siteLanguage,
  groupId
) => {
  return dispatch => {
    dispatch({ type: EDIT_PERSON });

    axios({
      method: 'PUT',
      url: `${API_URL}/persons/${uuid}`,
      headers: {
        Accept: 'application/json',
        'x-access-token': `${getCookie('user_token')}`
      },
      data
    }).then(response => {
      if (response.data.status === 200) {
        dispatch({
          type: EDIT_PERSON_SUCCESS,
          payload: response.data
        });
        setTimeout(() => {
          dispatch({
            type: RESET_PERSON_EDITED
          });
        }, 100);
        dispatch(
          fetchGroupPeople(groupId, userId, intl, siteLanguage, limit, page)
        );
        dispatch(fetchPeople(userId, limit, page, intl, siteLanguage));
        notification.success({
          message: intl.formatMessage(cw['SuccessUpdatePerson'])
        });
      } else if (
        response.data.status === 400 &&
        response.data.code === 'INVALID_PARAMETERS'
      ) {
        notification.error({
          message: intl.formatMessage(cw['FailedAddPerson']),
          description: intl.formatMessage(cw['InvalidInputs'])
        });
        dispatch({ type: EDIT_PERSON_FAILED });
      } else if (response.data.status === 400) {
        notification.error({
          message: intl.formatMessage(cw['FailedUpdatePerson'])
        });
        dispatch({ type: EDIT_PERSON_FAILED });
      } else if (
        response.data.status === 498 ||
        response.data.status === 401
      ) {
        dispatch(signOutUser(userId, intl, siteLanguage));
      } else {
        notification.error({ message: intl.formatMessage(cw['FailedUpdatePerson']) });
        dispatch({ type: EDIT_PERSON_FAILED });
      }
    }).catch(err => {
      dispatch({ type: EDIT_PERSON_FAILED });
      notification.error({ message: intl.formatMessage(cw['FailedUpdatePerson']) });
      bugsnagClient.notify(err);
    });
  };
};
